/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const overviewQueryInputDataDirectionSchema = z.enum(['asc', 'desc'])

export type OverviewQueryInputDataDirectionSchema = z.infer<typeof overviewQueryInputDataDirectionSchema>
